import { ACHWithdrawTransaction, ACHWithdrawTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchACHWithdrawTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);
  const [achWithdrawTransaction, setAchWithdrawTransaction] = useState<ACHWithdrawTransaction>();

  async function fetchAchWithdrawTransaction(params: ACHWithdrawTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.fetchACHWithdrawTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setAchWithdrawTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  function resetAchWithdrawTransaction() {
    setAchWithdrawTransaction(undefined);
  }

  return { fetching, achWithdrawTransaction, fetchAchWithdrawTransaction, resetAchWithdrawTransaction };
}
